
import {  Request } from '../../requets/shared/model/request.model';

export class AssigmentEvaluator {
  solicitudes: Request[];
  cedulaEvaludor: String;
}
